import React from 'react';
interface ChatMessageProps {
  initial: string;
  color: string;
  name: string;
  time: string;
  message: string;
}
function ChatMessage({
  initial,
  color,
  name,
  time,
  message
}: ChatMessageProps) {
  return <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200 mb-4 flex items-start" data-id="element-89">
      <div className={`w-10 h-10 rounded-full ${color} flex items-center justify-center text-white font-bold text-sm mr-4 flex-shrink-0`} data-id="element-90">
        {initial}
      </div>
      <div className="flex-1" data-id="element-91">
        <div className="flex justify-between items-baseline mb-1" data-id="element-92">
          <span className="font-bold text-sm text-gray-900" data-id="element-93">{name}</span>
          <span className="text-xs text-gray-400" data-id="element-94">{time}</span>
        </div>
        <p className="text-sm text-gray-600 leading-relaxed" data-id="element-95">{message}</p>
      </div>
    </div>;
}
export function ChatReactions() {
  const messages = [{
    initial: 'V',
    color: 'bg-green-500',
    name: 'Veerle',
    time: '10:33',
    message: 'Bedankt voor je lezing, je hebt op een duidelijke manier en met concrete voorbeelden veel inzicht bijgebracht!'
  }, {
    initial: 'L',
    color: 'bg-blue-500',
    name: 'Liset',
    time: '21:29',
    message: 'Super bedankt. Was boeiend en leerzaam.'
  }, {
    initial: 'L',
    color: 'bg-pink-500',
    name: 'Linda',
    time: '21:39',
    message: "leuk filmpje :-) Zie mezelf en mijn 'hondenkleinkids' :))) aangenaam verast. Dankjewel voor de masterclass"
  }, {
    initial: 'K',
    color: 'bg-purple-500',
    name: 'Karin',
    time: '21:40',
    message: 'Heel erg bedankt, het was heel leerzaam'
  }, {
    initial: 'A',
    color: 'bg-orange-500',
    name: 'Annemieke',
    time: '21:40',
    message: 'heel erg bedankt voor de masterclass! groetjes, Annemieke'
  }, {
    initial: 'C',
    color: 'bg-teal-500',
    name: 'Corrie',
    time: '21:40',
    message: 'Bedankt voor je heldere uitleg! Fijne avond'
  }];
  return <div className="my-16 bg-gray-50 p-8 rounded-xl border border-gray-200" data-id="element-96">
      <h3 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-97">
        Meer reacties van deelnemers
      </h3>
      <div className="space-y-4" data-id="element-98">
        {messages.map((msg, index) => <ChatMessage key={index} {...msg} data-id="element-99" />)}
      </div>
    </div>;
}